import {
  Document,
  Paragraph,
  TextRun,
  LevelFormat,
  AlignmentType,
  convertInchesToTwip,
  Footer,
  PageNumber,
  NumberFormat,
  ImageRun,
} from 'docx';
import { DocumentInput } from '../Report.types';
import { styles } from './reportThemes';
import { createSections } from './Functions/sections';
import { FrameworkRefs } from '../../Assessment';

export class EsrsDocumentCreator {
  public async create(input: DocumentInput, companyCurrency: string): Promise<Document> {
    const guidanceImage = await fetch('/images/guidance_word_report_purple.png').then(
      function (response) {
        return response.arrayBuffer();
      }
    );

    const document = new Document({
      creator: 'Celsia.io',
      revision: 1,
      subject: `${input.framework.charAt(0).toUpperCase() + input.framework.slice(1)} report`,
      title: `${input.data.companyName} - ${input.framework.toLocaleUpperCase()} report ${input.data.reportingYear}`,
      styles: styles,
      numbering: {
        config: [
          {
            reference: 'number-system',
            levels: [
              {
                level: 0,
                format: LevelFormat.UPPER_ROMAN,
                text: '%1.',
                alignment: AlignmentType.START,
                style: {
                  paragraph: {
                    indent: { left: convertInchesToTwip(0.25), hanging: convertInchesToTwip(0.25) },
                  },
                },
              },
            ],
          },
        ],
      },
      sections: [
        ...(input.framework === FrameworkRefs.esrs
          ? [
              {
                properties: {
                  page: {
                    margin: {
                      left: 0,
                      right: 0,
                      top: 0,
                      bottom: 0,
                    },
                    pageNumbers: {
                      start: 1,
                      formatType: NumberFormat.DECIMAL,
                    },
                  },
                },
                children: [
                  new Paragraph({
                    children: [
                      new ImageRun({
                        data: guidanceImage,
                        transformation: { width: 800, height: 1120 },
                        type: 'png',
                      }),
                    ],
                  }),
                ],
              },
            ]
          : []),
        {
          properties: {
            page: {
              margin: {
                left: convertInchesToTwip(1.25),
                right: convertInchesToTwip(1.25),
              },
              pageNumbers: {
                start: 2,
                formatType: NumberFormat.DECIMAL,
              },
            },
          },
          children: createSections(
            {
              categories: input.data.categories,
              companyName: input.data.companyName,
              reportingYear: input.data.reportingYear,
              materialStandards: input.data.materialStandards,
              structure: input.structure,
              framework: input.framework,
            },
            companyCurrency
          ),
          footers: {
            default: new Footer({
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      children: [PageNumber.CURRENT],
                    }),
                  ],
                  alignment: AlignmentType.CENTER,
                }),
              ],
            }),
          },
        },
      ],
    });

    return document;
  }
}
